// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.ScheduleMoveInCostsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ScheduleMoveInCostsWebApiRequestDto, ScheduleMoveInCostsWebApiResponseDto } from '../..';

export const ScheduleMoveInCostsWebApiHandler_scheduleMoveInCosts_Path = '/api/web/v1/scheduleMoveInCosts';

/**
 * Schedule move in costs
 */
export const ScheduleMoveInCostsWebApiHandler_scheduleMoveInCosts = (
  postData: ScheduleMoveInCostsWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ScheduleMoveInCostsWebApiRequestDto, ScheduleMoveInCostsWebApiResponseDto>(
    {
      endpoint: ScheduleMoveInCostsWebApiHandler_scheduleMoveInCosts_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
